export default __webpack_public_path__ + "static/media/2031.d1b6bca0.png";